module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/target01-a128839c00fb28f1908222cacd88d6a0.png";